import React from 'react';
import styles from './page6.scss';
import { getRem } from '../../func';

function Page6(props) {
  return (
    <div className={styles['page6']} ref={props.myRef}>
      <div className={styles['page6-main']}>
        <div className={`${styles['page6-title']} animate2-wrapper`}>
          <div r='220' g='221' b='235' className={`maskBlock animate2`} style={{ background: 'rgb(220, 221, 235)' }} />
          BRAND CONNOTATION
        </div>

        <div className={styles['page6-subTitle']}>
          <div className={styles['page6-subTitle-circle']}>3</div>
          <div className={styles['page6-subTitle-text']}>品牌内涵</div>
        </div>

        <div className={styles['page6-content']}>
          <div className={styles['page6-content-title']}>
            <span className={styles['main']}>品牌定位</span>
            <div className={styles['line']} />
          </div>
          <div className={styles['page6-content-text']}>立足中国的时尚产业垂直服务平台</div>

          <div className={styles['page6-content-title']}>
            <span className={styles['main']}>品牌使命</span>
            <div className={styles['line']} />
          </div>
          <div className={styles['page6-content-text']}>助力时尚产业把握中国市场的创新和发展</div>

          <div className={styles['page6-content-title']}>
            <span className={styles['main']}>品牌愿景</span>
            <div className={styles['line']} />
          </div>
          <div className={styles['page6-content-text']}>洞察与引领未来趋势，创享无限可能</div>

          <div className={styles['page6-content-title']}>
            <span className={styles['main']}>品牌语</span>
            <div className={styles['line']} />
          </div>
          <div className={styles['page6-content-text']}>
            WOW -TREND SHARING WHAT’S NEXT！<br />
            创享未来
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page6;